import { cameraApi } from "@/core/cameraApi";
import { useAppDispatch } from "@/hooks/redux";
import { useSelectedCameraStream } from "@/modules/camera-selection";
import { useCallback } from "react";

/**
 * Re-runs the camera API queries the live view depends on, for the current
 * selection. Backs the "Refresh" button on the no-camera screens.
 *
 * A plain refetch() of the cameras query isn't enough: an outage rejects the
 * streams (and NN) queries too, and a rejected query provides no tags, so it
 * is reachable neither by tag invalidation nor by the cameras refetch. Without
 * streams the auto-pick in useSelectedCameraStream never fires and the stream
 * stays unselected even though the camera is back. initiate({forceRefetch})
 * re-runs them regardless of their current state; subscribe: false keeps this
 * from adding cache subscriptions the caller would have to release.
 */
export const useCameraApiRetry = () => {
  const dispatch = useAppDispatch();
  const { cameraMxid, streamName } = useSelectedCameraStream();

  return useCallback(() => {
    dispatch(
      cameraApi.endpoints.listCameras.initiate(undefined, {
        forceRefetch: true,
        subscribe: false,
      }),
    );
    if (cameraMxid) {
      dispatch(
        cameraApi.endpoints.listStreams.initiate(cameraMxid, {
          forceRefetch: true,
          subscribe: false,
        }),
      );
      if (streamName) {
        dispatch(
          cameraApi.endpoints.getNN.initiate(
            { mxid: cameraMxid, streamName },
            { forceRefetch: true, subscribe: false },
          ),
        );
      }
    }
  }, [dispatch, cameraMxid, streamName]);
};
